import React from 'react';

interface ClearLogsConfirmPopupProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirmClear: () => void;
  selectedCount: number;
}

const ClearLogsConfirmPopup: React.FC<ClearLogsConfirmPopupProps> = ({
  isOpen,
  onClose,
  onConfirmClear,
  selectedCount
}) => {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 2002,
        padding: 20
      }}
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: 'white',
          borderRadius: 12,
          maxWidth: 450,
          width: '100%',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
          fontFamily: 'system-ui, -apple-system, sans-serif'
        }}
      >
        {/* Header */}
        <div style={{
          padding: '20px 24px',
          borderBottom: '1px solid #e5e7eb'
        }}>
          <h2 style={{
            margin: 0,
            fontSize: 18,
            fontWeight: 600,
            color: '#111827'
          }}>
            Clear Alerts
          </h2>
          <p style={{
            margin: '4px 0 0 0',
            fontSize: 13,
            color: '#6b7280'
          }}>
            Do you want to clear {selectedCount} alert{selectedCount !== 1 ? 's' : ''}?
          </p>
        </div>

        {/* Content */}
        <div style={{ padding: '24px' }}>
          <div style={{
            background: '#fef3c7',
            border: '1px solid #fcd34d',
            borderRadius: 8,
            padding: 16,
            marginBottom: 16
          }}>
            <div style={{
              fontSize: 13,
              color: '#78350f',
              lineHeight: 1.5
            }}>
              <strong>Note:</strong> Press <strong>Confirm</strong> button on individual alerts if you want to create a ticket instead of clearing.
            </div>
          </div>
        </div>

        {/* Footer */}
        <div style={{
          padding: '16px 24px',
          borderTop: '1px solid #e5e7eb',
          display: 'flex',
          justifyContent: 'flex-end',
          gap: 12
        }}>
          <button
            onClick={onClose}
            style={{
              background: 'white',
              color: '#374151',
              border: '1px solid #d1d5db',
              borderRadius: 6,
              padding: '8px 16px',
              fontSize: 13,
              fontWeight: 500,
              cursor: 'pointer',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#f9fafb';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'white';
            }}
          >
            Cancel
          </button>
          <button
            onClick={() => {
              onConfirmClear();
              onClose();
            }}
            style={{
              background: '#dc2626',
              color: 'white',
              border: 'none',
              borderRadius: 6,
              padding: '8px 16px',
              fontSize: 13,
              fontWeight: 500,
              cursor: 'pointer',
              transition: 'background 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#b91c1c';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = '#dc2626';
            }}
          >
            Yes, Clear Alerts
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClearLogsConfirmPopup;
